import { useRecoilCallback } from 'recoil';
import { AnnotationRecord } from '~/domain/annotation/annotation';
import {
    addAnnotation,
    AnnotationListState,
} from '~/state/atoms/annotationListAtoms';

/**
 * Returns a stable callback that appends a placed annotation to its list:
 * its atom is set and its id joins the list in one update. It may be called
 * from outside React, as an engine tool's commit is.
 */
export function useAddAnnotation(): <T extends AnnotationRecord>(
    list: AnnotationListState<T>,
    annotation: T
) => void {
    return useRecoilCallback(
        (callback) =>
            <T extends AnnotationRecord>(
                list: AnnotationListState<T>,
                annotation: T
            ) =>
                addAnnotation(callback, list, annotation),
        []
    );
}
